import { render } from "./SliderOwn.vue?vue&type=template&id=3c66dea3&scoped=true"
import script from "./SliderOwn.vue?vue&type=script&lang=js"
export * from "./SliderOwn.vue?vue&type=script&lang=js"

import "./SliderOwn.vue?vue&type=style&index=0&id=3c66dea3&scoped=true&lang=css"

import exportComponent from "/Users/adrianfraczak/Projects/Freaz/rk/rk.off-vue/rk.off-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c66dea3"]])

export default __exports__